import React, { useContext, useEffect, useState } from "react";
import Contexto from "../context/Contexto";
import Arrow from "../assets/CCstatics/Arrow-1.png";

import "../assets/css/MiCurso.css";

const PresetComprado = (props) => {
  const { bajarPreset } = useContext(Contexto);

  const [preset, setPreset] = useState({ preset: "", instructivo: "" });

  const { uid, nombre, img_prod, _color_, url, history } = props;
  useEffect(() => {
    //props.bajarPreset(url.substr(1));
    setPreset();
  }, []);

  // eslint-disable-next-line
  let qr;

  const handleVer = (e) => {
    let nombre = e.target.getAttribute("name");
    bajarPreset(url.substr(1), nombre);
  };

  return (
    <React.Fragment>
      <div className={"item-curso"} style={{ background: "#4abdf1" }}>
        <div className="cursoComprado__info">
          <p className="otra">{nombre}</p>
          <div className="cursoComprado--btn blanco cursor" onClick={handleVer}>
            Bajar Presets <img src={Arrow} alt="" className=" flechita" />
          </div>
          <div
            className="cursoComprado--btn blanco cursor"
            name="ver"
            onClick={handleVer}
          >
            Bajar instrucciones <img src={Arrow} alt="" className="flechita" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PresetComprado;
